module.exports = __webpack_public_path__ + "static/media/image_28.32b533c8.png";